import { all, call, takeLatest } from 'redux-saga/effects'
import store from 'store'
import { AuthTypes } from 'Redux/AuthRedux'

// Storage keys (following appointo_client pattern)
const AUTH_DATA_KEY = 'authData'
const USER_DATA_KEY = 'userData'
const TEAM_KEY = 'video_panda_team'

// Sign In - following appointo_client pattern
export function* onSignIn(api, action) {
  const resp = yield call(api.signIn, action.params)
  
  if (resp.ok) {
    const { token, user, teams } = resp.data
    
    // Store auth data (following appointo_client pattern)
    const authData = { token }
    store.set(AUTH_DATA_KEY, authData)
    store.set(USER_DATA_KEY, { ...user, teams })
    
    const teamId = teams?.[0]?.id
    if (teamId) {
      store.set(TEAM_KEY, teamId)
    }

    // Set API headers
    yield call(api.setAuthData, { token, teamId })

    action.callback(resp, null)
  } else {
    const error = resp.data?.error || 'Invalid email or password'
    action.callback(null, error)
  }
}

// Sign Up - following appointo_client pattern
export function* onSignUp(api, action) {
  const resp = yield call(api.signUp, action.params)
  
  if (resp.ok) {
    const { token, user, teams } = resp.data
    
    // Store auth data
    const authData = { token }
    store.set(AUTH_DATA_KEY, authData)
    store.set(USER_DATA_KEY, { ...user, teams })
    
    const teamId = teams?.[0]?.id
    if (teamId) {
      store.set(TEAM_KEY, teamId)
    }

    // Set API headers
    yield call(api.setAuthData, { token, teamId })

    action.callback(resp, null)
  } else {
    let error = 'There was an error creating your account. Please try again'
    if (resp.data?.error) {
      error = resp.data.error
    } else if (resp.data?.errors === 'email_exist') {
      error = 'Email already exists. Please try another email'
    }
    action.callback(null, error)
  }
}

// Sign Out - following appointo_client pattern
export function* onSignOut(api, action) {
  try {
    yield call(api.signOut)
  } catch (error) {
    // Ignore sign out API errors
    console.error('Sign out API error:', error)
  }

  // Clear stored data
  store.remove(AUTH_DATA_KEY)
  store.remove(USER_DATA_KEY)
  store.remove(TEAM_KEY)

  // Clear API headers
  yield call(api.deleteAuthData)
  
  if (action.callback) {
    action.callback()
  }
}

// Me Request - following appointo_client pattern
export function* meRequest(api, action) {
  const resp = yield call(api.getCurrentUser)
  
  if (resp.ok) {
    const { user, teams } = resp.data
    store.set(USER_DATA_KEY, { ...user, teams })
    if (action.callback) {
      action.callback(resp, null)
    }
  } else {
    if (action.callback) {
      action.callback(null, 'Failed to get user')
    }
  }
}

// Switch Team
export function* switchTeam(api, action) {
  const { teamId, callback } = action

  // Update stored team
  store.set(TEAM_KEY, teamId)

  // Update API header
  yield call(api.setTeamId, teamId)
  
  if (callback) {
    callback()
  }
}

// Watcher saga
export default function* authSaga(api) {
  yield all([
    takeLatest(AuthTypes.SIGN_IN_REQUEST, onSignIn, api),
    takeLatest(AuthTypes.SIGN_UP_REQUEST, onSignUp, api),
    takeLatest(AuthTypes.SIGN_OUT_REQUEST, onSignOut, api),
    takeLatest(AuthTypes.ME_REQUEST, meRequest, api),
    takeLatest(AuthTypes.SWITCH_TEAM, switchTeam, api),
  ])
}
